import { render, staticRenderFns } from "./setting-profile.vue?vue&type=template&id=0895e06b&scoped=true&"
import script from "./setting-profile.vue?vue&type=script&lang=js&"
export * from "./setting-profile.vue?vue&type=script&lang=js&"
import style0 from "./setting-profile.vue?vue&type=style&index=0&id=0895e06b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895e06b",
  null
  
)

export default component.exports